export const getActionInProgressState = state => state.actionInProgress;
